@let context = store.$context();
@let header = $safeNavigationMigration(context?.header);
@let primaryCommands = $primaryCommands();
@let moreCommands = $moreCommands();
@let addCommands = $addCommands();
@let compact = $compact();
@let settingsOpen = store.$viewSettingsOpen();
@let viewOptions = $viewOptions();
@let navigation = $showCalendarNavigation() ? store.$headerNavigation() : null;

@if (settingsOpen) {

  <div class="header-row header-row-settings-mode">
    @if($showHeaderTitle()) {
      <div class="title-area">
        <span class="title-text">{{header.title}}</span>
        @if (header.titleBadge?.label) { <wb-badge class="title-badge" mode="squared" size="small" [label]="header.titleBadge.label" backgroundColor="var(--local-board-header-title-badge-bg)" color="var(--local-board-header-title-badge-color)" borderColor="var(--local-board-header-title-badge-border)" /> }
      </div>
    }
  </div>

} @else {

  @if (navigation) {
    <w-page class="board-header-page" [hideBody]="true" [hideFooter]="true" [hideClose]="true" headerSize="small">
      <ng-template w-page-header-title>
        <div class="header-row-normal header-calendar-identity">
          <ng-container [ngTemplateOutlet]="identityTpl" />
        </div>
      </ng-template>
      <ng-template w-page-header-center>
        <board-header-navigation [navigation]="navigation" />
      </ng-template>
      <ng-template w-page-header-actions>
        <div class="header-row-normal header-calendar-actions">
          <ng-container [ngTemplateOutlet]="actionsTpl" />
        </div>
      </ng-template>
    </w-page>
  } @else {
    <div class="header-row header-row-normal" [class.segments-stacked]="$segmentsStacked()">
      <ng-container [ngTemplateOutlet]="identityTpl" />
      <ng-container [ngTemplateOutlet]="actionsTpl" />
    </div>
  }
  @if (!compact) {
    <wb-filter-bar class="header-row header-filter" [class.filter-bar-hidden]="!filterBar.$hasFilters()" [quickFilterIds]="store.$quickFilterFieldIds()" [blockedFieldIds]="store.$hiddenFilterFieldIds()" [allowAdvancedFilter]="store.$allowAdvancedQuery()" [value]="store.filterValues()" (valuesChange)="onFilterValuesChanged($event)" #filterBar />
  }

}

@if(header?.refreshNotice?.visible()) {
  <div class="header-row header-refresh-notice">
    <div class="refresh-notice-content">
      <span>{{ header.refreshNotice.label }}</span>
      <button type="button" (click)="onRefreshNotice()">{{ header.refreshNotice.actionLabel }}</button>
    </div>
  </div>
}

@if(store.$paged() && store.$layout() === 'default' && !$previewPanelOpen()) {
    <!-- With the preview panel open the paginator renders in the board's split footer instead. A
         quickview has no such footer, so the header keeps it. -->
    <div class="header-row header-paging">
        <ng-container [ngTemplateOutlet]="paginatorTpl" />
    </div>
}

<ng-template #paginatorTpl>
    @if (store.$countless()) {
        <!-- A reader that never counts cannot say how many pages there are, so there is no "of M", no
             row total and no jump-to-last. Next is offered while the response says another page exists. -->
        <div class="countless-paginator">
            <wb-button class="countless-prev" iconLeft="fa-regular fa-angle-left" tooltip="Previous page" [disabled]="store.$page() <= 0" displayStyle="Tertiary" (onClick)="onCountlessPrevious()" />
            <span class="countless-page">Page {{ store.$page() + 1 }}</span>
            <wb-button class="countless-next" iconLeft="fa-regular fa-angle-right" tooltip="Next page" [disabled]="!store.$hasMore()" displayStyle="Tertiary" (onClick)="onCountlessNext()" />
        </div>
    } @else {
        <!-- The report slot always renders. While the first query is pending it says so rather than
             reporting "Showing 0 - 0 of 0" — a count the server has not returned — and rather than
             going blank, which would collapse the row and re-centre the arrows until the count
             landed. Same slot, same type: only the text changes. -->
        <p-paginator class="board-paginator" [alwaysShow]="true" [showCurrentPageReport]="store.$layout() !== 'focus'" [currentPageReportTemplate]="$pageReportTemplate()" [pageLinkSize]="5" [rows]="store.$effectivePageSize()" [first]="$paginatorFirst()" [totalRecords]="store.$total()" (onPageChange)="onPageChange($event)" #pager />
    }
</ng-template>

<ng-template #identityTpl>

      @if($showHeaderTitle()) {
          <div class="title-area">
              <span class="title-text">{{header.title}}</span>
              @if (header.titleBadge?.label) { <wb-badge class="title-badge" mode="squared" size="small" [label]="header.titleBadge.label" backgroundColor="var(--local-board-header-title-badge-bg)" color="var(--local-board-header-title-badge-color)" borderColor="var(--local-board-header-title-badge-border)" /> }
          </div>
      }

      @if($showViewDropdown() || $singleView() || $showViewFavorite() || viewOptions.create || viewOptions.edit) {

          <div class="views">

              @if($showViewDropdown()) {
                  <div class="view-selector">
                      <wb-button-dropdown [commands]="$viewSelectorCommands()" (onCommandChanged)="onViewChanged($safeNavigationMigration($event?.data))" menuAlignment="Left" />
                  </div>
              } @else if ($singleView(); as view) {
                  <div class="view-selector">
                      <wb-button class="single-view-selector" [label]="view.label" [tooltip]="view.label" [iconLeft]="view.iconLeft" [disabled]="true" />
                  </div>
              }

              @if($showViewFavorite()) {
                  <wb-button-icon class="view-favorite" [command]="store.$viewFavoriteCommand()" displayStyle="Tertiary" />
              }
              @if(viewOptions.create || viewOptions.edit) {
                  <div class="view-actions">
                      @if(viewOptions.create) {
                          <wb-button-icon [command]="store.viewCreateCommand" displayStyle="Tertiary" />
                      }
                      @if(viewOptions.edit && store.$view()) {
                          <wb-button-icon [command]="store.viewEditCommand" displayStyle="Tertiary" />
                      }
                  </div>
              }

          </div>

      }

      @if ($periodConfig()) {
        <!-- Beside the view switcher: the period is not a filter, it is what
             makes this board finite, so it reads as part of the board's identity rather than as
             something added on top of it. Rendered on EVERY display a period-declared board offers,
             Calendar included — it is the one control that means the same thing whether the board
             draws a grid or a table, so the calendar's own toolbar stands down for it. -->
        @if ($periodRange(); as range) {
          <filter-period
            class="header-period"
            [options]="$periodOptions()"
            [range]="range"
            [rangeLabel]="$periodRangeLabel()"
            [custom]="$periodCustom()"
            [nextDisabled]="$periodNextBlocked()"
            [maxDate]="$periodMaxDate()"
            (presetChange)="onPeriodPreset($event)"
            (step)="onPeriodStep($event)"
            (customChange)="onPeriodCustom($event)"
          />
        }
      }

      <div class="header-after-views">
        @if ($showViewPills()) {
          <board-view-pills />
        }
        <ng-content select="[board-header-after-views]" />
      </div>

</ng-template>

<ng-template #actionsTpl>
      <div class="module-options">
          @for (primary of primaryCommands; track primary.command) {
              @if (primary.commands?.length) {
                  <wb-button-split [command]="primary.command" [commands]="primary.commands" [displayStyle]="primary.displayStyle ?? ButtonDisplayStyle.Secondary" />
              } @else {
                  <wb-button [command]="primary.command" [displayStyle]="primary.displayStyle ?? ButtonDisplayStyle.Secondary" />
              }
          }
          @if(moreCommands?.length) {
              <!-- Secondary to match filter/display/refresh; default icon size (Large was oversized in 24px chrome). -->
              <wb-button-menu iconLeft="fa-regular fa-ellipsis" [showCaret]="false" [commands]="moreCommands" />
          }
      </div>

      @if(header?.showSearch) {
          <div class="view-options search-area">
              @if (navigation && compact) {
                <wb-button-overlay iconLeft="fa-regular fa-magnifying-glass" tooltip="Search" [showCaret]="false" overlayClass="board-header-search-overlay">
                  <ng-template buttonOverlayContent>
                    <w-search [value]="store.$search() ?? ''" (search)="onSearch($event)" />
                  </ng-template>
                </wb-button-overlay>
              } @else {
                <w-search [value]="store.$search() ?? ''" (search)="onSearch($event)" />
              }
          </div>
      }

      @if (store.$view() && $showBoardControls()) {
        <div class="view-options board-controls">
            @if (compact) {
                <wb-button-overlay iconLeft="fa-regular fa-bars-filter" tooltip="Filters" [label]="navigation ? 'Filters' : undefined" [showCaret]="false" overlayClass="board-filters-overlay" [nestedOverlays]="true" [count]="store.$filterCount() || null" [buttonClass]="store.$filterCount() ? 'w-button-filtered' : null">
                    <ng-template buttonOverlayContent>
                        <div class="board-filters-panel">
                            <div class="board-filters-panel-title">Filters</div>
                            <wb-filter-bar orientation="vertical" size="Small" [quickFilterIds]="store.$quickFilterFieldIds()" [blockedFieldIds]="store.$hiddenFilterFieldIds()" [allowAdvancedFilter]="store.$allowAdvancedQuery()" [value]="store.filterValues()" (valuesChange)="onFilterValuesChanged($event)" #filterBar />
                        </div>
                    </ng-template>
                </wb-button-overlay>
            } @else {
                <wb-button-menu iconLeft="fa-regular fa-bars-filter" [showCaret]="false" overlayClass="view-filters-overlay" [commands]="$filterCommands()" [count]="store.$filterCount() || null" label="Filter" [buttonClass]="store.$filterCount() ? 'w-button-filtered' : null" (onCommandChanged)="onAddFilter($event);filterButton.hideMenu()" #filterButton />
            }

            <wb-button-overlay iconLeft="fa-regular fa-sliders" menuAlignment="Right" overlayClass="display-settings-overlay" [showCaret]="false" #displaySettingsOverlay>
                <ng-template buttonOverlayContent>
                    <!-- Display switching is locked only when the context forces a layout (display changes
                         would be ignored) or for entity queues; otherwise the offered board types come
                         from the entity manifest (e.g. financial docs: Card / Table, preview toggled per view). -->
                    <display-settings [config]="store.$displaySettingsConfig()" [lockDisplay]="store.$context()?.layout != null || store.$context()?.entity === ActivityEntityName.EntityQueue" [displayTypes]="$displayTypes()" [previewSupported]="store.$panelKind() === 'preview'" [paged]="store.$paged()" [listConfig]="store.$context()?.list ?? null" [reorderConfig]="store.$context()?.reorder ?? null" [displaySettings]="store.$context()?.displaySettings ?? null" [isEmbedded]="!!store.$contextIsEmbedded()" [compact]="compact" [showDisplaySwitcher]="!!store.$context()?.header?.showDisplaySwitcher" [canEditView]="$canEditView()" [viewDisplay]="$viewDisplay()" (valueChange)="onDisplaySettingsChange($event)" (defaultDisplayRequested)="onSetDefaultDisplay($event)" (resetRequested)="onResetDisplaySettings(); displaySettingsOverlay.hideMenu()" (closed)="displaySettingsOverlay.hideMenu()" />
                </ng-template>
            </wb-button-overlay>

            <wb-button [command]="store.refreshCommand" />

            <!-- Only route back from an explicit close: the panel's own X sets a session-local flag
                 that nothing else clears until the board's context changes. -->
            @if ($panelReopenable()) {
              <wb-button-icon iconLeft="fa-regular fa-table-columns" displayStyle="Tertiary" size="Small" tooltip="Show panel" (onClick)="store.reopenPanel()" />
            }
        </div>
      }

      @if(store.$showAdd()) {
          <div class="add-area">
              @if(addCommands?.length) {
                  @if($addAsMenu()) {
                      <wb-button-menu [command]="store.addCommand" [commands]="addCommands" [showCaret]="false" displayStyle="Primary" />
                  } @else {
                      <wb-button-split [command]="store.addCommand" [commands]="addCommands" displayStyle="Primary" />
                  }
              } @else {
                  <wb-button [command]="store.addCommand" displayStyle="Primary" />
              }
          </div>
      }

      @if(store.$showClose()) {
          <div class="add-area">
              <wb-button [command]="store.closeCommand" displayStyle="Tertiary" />
          </div>
      }

</ng-template>
